import React, { Component } from 'react'
import { base } from '../../base';
import SideMenu from '../admin/SideMenu';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import '../../styles/css/AdminMain.css'

class SetUpSessions extends Component {
    constructor(props) {
        super(props);

        this.state = {
          questionList: [],
          sessionList: [],
          attachedQuestions: [],
          selectedSession: {},
          modal: false
        };
        this.toggle = this.toggle.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillMount() {
      this.ref = base.bindToState(`questionList`, {
        context: this,
        state: 'questionList',
        asArray: true
      });
      this.sessions = base.syncState(`sessionList`, {
        context: this,
        state: 'sessionList',
        asArray: true
      });
      this.session_count = base.syncState(`session_count`, {
        context: this,
        state: 'session_count'
      });
    }

    componentWillUnmount() {
      base.removeBinding(this.ref);
      base.removeBinding(this.sessions);
      base.removeBinding(this.session_count);
    }

    handleSubmit(event) {
      event.preventDefault();
      const data = new FormData(event.target);
      var sessionCount = this.state.session_count
      var sideSession = data.get('sideSession')
      var sessionName = data.get('name');
      var attachedQuestions = this.state.attachedQuestions;
      if(!sessionName || attachedQuestions.length === 0){
        alert("Please add all necessary info");
        return;
      }
      if(sideSession){
        sideSession = true
      }
      var vm = this;
      base.post('sessionList/'+ sessionCount, {
        data: {sessionName: sessionName, questions: attachedQuestions, id: sessionCount, votingOn: false, sideSession: sideSession},
        then(err){
          if(!err){
            document.getElementById("create-session-form").reset();
            sessionCount = sessionCount + 1
            vm.setState({
              selectedSession: {},
              attachedQuestions: [],
              session_count: sessionCount
            })
          }
        }
      })

    }

    deleteSession(e){
      e.preventDefault();
      var array = this.state.sessionList;
      var index = array[e.target.value];
      //eslint-disable-next-line
      var result = confirm("Delete Session? ALL DATA ASSOCIATED WITH IT WILL BE LOST");
      if (result) {
        base.remove('sessionList/' + index.key, function(err) {
          if(err){
            alert("Something went wrong!")
          }
        })
      }
    }

    appendInput(question){
      //eslint-disable-next-line
      var result = confirm("Add Question?");
      if (result) {
        var attachedQuestionArray = this.state.attachedQuestions
        attachedQuestionArray.push(question);
        this.setState({
          attachedQuestions: attachedQuestionArray,
        })
      }
    }

    toggle() {
      this.setState({
        modal: !this.state.modal,
        selectedSession: {},
        attachedQuestions: [],
      });
    }

    render() {
        return (
          <div className="admin-wrapper">
            <SideMenu/>
            <div className="admin-main-panel">
              <div className="container" align="center">
                  <h1>Set Up Sessions</h1>
                  <Button className="btn btn-default btn-admin btn-create-question" onClick={this.toggle}>New Session <i className="fa fa-plus" aria-hidden="true"></i></Button>
              </div>
              <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                <ModalHeader toggle={this.toggle}>Add/Edit A Session</ModalHeader>
                  <ModalBody>
                    <div className="container-out">
                      <div className="question-box question-form">
                        <form onSubmit={this.handleSubmit} id="create-session-form">
                          <div className="form-group">
                            <label htmlFor="name">Enter Session Name: </label>
                            <input id="name" name="name" type="text" className="form-control" defaultValue={""}/>
                          </div>
                          <div className="form-inline">
                            <label htmlFor="name">Side Session: </label>
                            <input id="sideSession" name="sideSession" type="checkbox" className="form-control"/>
                          </div>
                          <div className="form-group">
                            <label htmlFor="name">Add Question: </label>
                            <select className="form-control" multiple>
                              {
                                this.state.questionList.map(function(item,i){
                                  return <option value={item.key} key={i} onClick={ () => this.appendInput(item)}>{item.question}</option>
                                }, this)
                              }
                            </select>
                          </div>
                          {
                            this.state.attachedQuestions.length > 0 ? (
                              <div>
                              {
                                this.state.attachedQuestions.map(function(item,i){
                                  return <div key={i}>
                                    {item.question}
                                  </div>
                                })
                              }
                              </div>
                            ) : (
                              <h4>No Questions Added!</h4>
                            )
                          }
                          <button className="btn btn-default btn-admin">Submit</button>
                        </form>
                      </div>
                    </div>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="secondary" onClick={this.toggle}>Close</Button>
                  </ModalFooter>
              </Modal>
                  <h2 className="lines-on-sides">Sessions</h2>
                  <div className="admin-grid-container">
                  {
                    this.state.sessionList.map(function(item,i){
                      return <div key={i} className="question-box">
                          <p><strong>Session Name:</strong> {item.sessionName}</p>
                          <p><strong>ID:</strong> {item.id}</p>
                          <ol>
                          {
                            item.questions.map(function(question,t){
                              return <li key={t}>{question.question}</li>
                            })
                          }
                          </ol>
                          <button className="btn btn-default btn-admin" onClick={this.deleteSession.bind(this)} value={i}>DELETE</button>
                        </div>
                    }, this)
                  }
                  </div>
            </div>
         </div>
        );
    }
}

export default SetUpSessions;



// WEBPACK FOOTER //
// ./src/components/admin/SetUpSessions.js